import { render } from "./pantallas_g.vue?vue&type=template&id=00a5648b"
import script from "./pantallas_g.vue?vue&type=script&lang=js"
export * from "./pantallas_g.vue?vue&type=script&lang=js"

import "./pantallas_g.vue?vue&type=style&index=0&id=00a5648b&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__